// Editorial slow marquee — compact, single-line, theme-aware.
// Solid muted text that adapts to light/dark automatically via CSS variables.
export default function Marquee({ items = [], className = '' }) {
  const seq = [...items, ...items, ...items];
  return (
    <div
      className={`relative overflow-hidden select-none ${className}`}
      aria-hidden
      style={{
        borderTop: '1px solid var(--hairline)',
        borderBottom: '1px solid var(--hairline)',
        background: 'var(--surface)',
      }}
    >
      {/* Edge fade masks — subtle */}
      <div
        className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 z-10"
        style={{ background: 'linear-gradient(to right, var(--surface), transparent)' }}
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 z-10"
        style={{ background: 'linear-gradient(to left, var(--surface), transparent)' }}
      />

      <div className="flex whitespace-nowrap animate-marquee-slow py-4 md:py-6 gap-10 md:gap-16">
        {seq.map((t, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-10 md:gap-16 font-display italic text-2xl md:text-3xl lg:text-[34px] leading-none tracking-tight"
            style={{ color: 'rgba(var(--fg-rgb), 0.72)' }}
          >
            {t}
            <span
              aria-hidden
              className="inline-block h-[6px] w-[6px] rounded-full"
              style={{ background: 'rgba(var(--fg-rgb), 0.35)' }}
            />
          </span>
        ))}
      </div>
    </div>
  );
}
